module.exports = __webpack_public_path__ + "32ce38a4102a9a0db6d72aedb64f33d2.png";